
    <div class="m-2 mt-4 mb-4 w-100">
      <div fieldmagicGridRow>
        <div fieldmagicGridColumn="12">
          <fieldmagic-text
            content="Configurations"
          >
          </fieldmagic-text>

          <hr class="w-100" />

          <div class="d-flex d-flex-gap flex-column">
            <fieldmagic-primary-button
              label="Reset Columns"
              icon="sync-alt"
              (click)="onResetColumns()"
            >
            </fieldmagic-primary-button>
          </div>
        </div>
      </div>
    </div>
  